import { ErrorBoundary, FallbackRender } from '@sentry/react'
import { ReactNode } from 'react'

export const SiteMetricsErrorBoundary = ({ children, fallback }: { children: ReactNode; fallback: FallbackRender }) => {
  return <ErrorBoundary fallback={fallback}>{children}</ErrorBoundary>
}

export const dynamicImportErrors = [
  'Failed to fetch dynamically imported module',
  'TypeError: Load failed',
  'Importing a module script failed',
  'Unable to preload CSS'
]
